/* eslint-disable max-len */
import React from 'react'
import Loader from './Loader'

export default function Button({ smallLoader, handleClick,loading,disabled,text,classKey,type,testId,color }) {
    return (
        <button 
            onClick={handleClick}
            disabled={disabled}
            type={type}
            data-testid={testId}
            id="login-form" 
            className={classKey}>
            {!loading?text:<span>{<Loader smallLoader={smallLoader} color={color}/>}</span>}
            
        </button>
    )
}
